import React, { memo, useMemo } from 'react';
import CreateButton from './CreateButton';
import BackButton from './BackButton';
import Breadcrumb from './Breadcrumb';
import TrailDetailsContainer from '../dashboard/admin/trails/containers/trail-details.container';
import { Alert, Tag, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useActiveTenant } from '../../states/active-tenant.atom';
import { useAuthUser } from '../../states/user.atom';
import EditButton from './EditButton';

interface HeaderRowProps {
  title: string;
  createRoute?: string;
  showBackButton?: boolean;
  showCreateButton?: boolean;
  showEditButton?: boolean;
  editRoute?: string;
  showBreadcrumbs?: boolean;
  customContent?: React.ReactNode;
  trailTarget?: string;
  isSysAdmin?: boolean;
}

const HeaderRow: React.FC<HeaderRowProps> = ({
  title,
  createRoute = '',
  showBackButton = false,
  showCreateButton = false,
  showEditButton = false,
  editRoute = '',
  showBreadcrumbs = true,
  customContent,
  trailTarget,
  isSysAdmin = false,
}) => {
  const { t } = useTranslation();
  const { activeTenant } = useActiveTenant();
  const { isSysAdmin: isSysAdminUser } = useAuthUser();
  const showSelectTenantBanner = useMemo(() => {
    return !isSysAdmin && !activeTenant && isSysAdminUser;
  }, [activeTenant, isSysAdmin, isSysAdminUser]);
  return (
    <>
      <div className="row">
        {showSelectTenantBanner && (
          <Alert
            showIcon
            type="warning"
            message={t('tenants.selectTenantBanner')}
            banner
            className="mb-3"
          />
        )}
        <div className="col-md-5 d-flex align-items-center gap-3">
          <Typography.Title level={2} className="fw-bolder">
            {title}
          </Typography.Title>
          {isSysAdmin && (
            <Tag color="black" className="mb-2 ml-2">
              {t('common.systemAdmin')}
            </Tag>
          )}
        </div>
        <div className="col-md-7 d-flex justify-content-end gap-2">
          {customContent}
          {trailTarget && <TrailDetailsContainer id={trailTarget} />}
          {showBackButton && <BackButton />}
          {showCreateButton && createRoute && <CreateButton route={createRoute} />}
          {showEditButton && editRoute && <EditButton route={editRoute} />}
        </div>
      </div>
      <div className="row">
        {showBreadcrumbs && (
          <div className="col-12 mb-3">
            <Breadcrumb />
          </div>
        )}
      </div>
    </>
  );
};

export default memo(HeaderRow);
